namespace Controlli {
    export namespace Mixed {
        export function Render(options: ChartOptions) {
            ChartsGlobal.RenderChart(options.DivIdValue, InitParams(options))
        }

        function InitParams(initOptions: ChartOptions): Object {
            let plotHeight = (initOptions.ChartHeight == null || initOptions.ChartHeight == 0 ? 500 : initOptions.ChartHeight);
            let columnW = (initOptions.PlotSize == null || initOptions.PlotSize == 0 ? "80%" : initOptions.PlotSize + "%");
            let barH = (initOptions.BarHeight == null || initOptions.BarHeight == 0 ? "70%" : initOptions.BarHeight + "%");
            let showAxisY = true;
            let showDataLabels = false;
            
            initOptions.Series.Series.forEach((valore) => {
                valore.color = Controlli.Utility.GetChartColor(valore.color);
            })

            let result = {
                series: initOptions.Series.Series,
                chart: {
                    id: initOptions.ChartId,
                    height: plotHeight,
                    type: initOptions.Type,
                    toolbar: {
                        show: true,
                        tools: {
                            download: false,
                            selection: false,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: false,
                            reset: '<i class="fa-duotone fa-rotate-left fa-xl"></i>',
                            customIcons: []
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: columnW,
                        barHeight: barH,
                    },
                },
                dataLabels: {
                    enabled: showDataLabels,
                },
                stroke: {
                    curve: "straight",
                    dashArray: [0, 8],
                    width: [0, 2.2],
                },
                markers: {
                    size: [0, 0, 0],
                    strokeWidth: 2,
                    hover: {
                        size: 4,
                    },
                },
                grid: {
                    show: true,
                    xaxis: {
                        lines: {
                            show: true
                        }
                    },
                    yaxis: {
                        lines: {
                            show: true
                        }
                    },
                    padding: {
                        top: 0,
                        right: -2,
                        bottom: 15,
                        left: 10,
                    },
                },
                fill: {
                    opacity: [0.9, 1],
                },
                legend: {
                    show: true,
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: -5,
                    markers: {
                        width: 9,
                        height: 9,
                        radius: 6,
                    },
                    itemMargin: {
                        horizontal: 10,
                        vertical: 0,
                    },
                },
                xaxis: {
                    categories: initOptions.Series.Categories,
                    axisTicks: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },
                },
                yaxis: {
                    show: showAxisY,
                    max: initOptions.MaxStepsValue,
                },
                tooltip: {
                    shared: true,
                    y: [{
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0);
                            }
                            return y;
                        },
                    },
                    {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0);
                            }
                            return y;
                        },
                    },
                    {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0);
                            }
                            return y;
                        },
                    },
                    ],
                },
            };
            return result;
        }

        //Contain the parameters for setting up the donut chart
        export class ChartOptions extends ChartsGlobal.BaseChart {
            CategoriesAxisX: Set<string>;
            Series: ChartsData;
            BarHeight: number;
            MaxStepsValue: number;
        }

        class ChartsData {
            Categories: Array<string>;
            Series: Array<ChartSerie>
        }

        class ChartSerie {
            name: string
            data: object[]
            color: string
            type: string
        }

    }
}